export default __webpack_public_path__ + "static/media/eugene-yan.b3ad0e9d.png";